import { createAddress } from "../../api/addressController";

export const createAddressData = async ({
	firstName,
	lastName,
	streetAddress,
	countryId,
	suburb,
	city,
	postalCode,
	provinceId,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const body = {
			firstName: firstName,
			lastName: lastName,
			countryId: countryId,
			suburb: suburb,
			city: city,
			postalCode: postalCode,
			provinceId: provinceId,
			streetAddress: streetAddress
		};
		let response = await createAddress(body);

		if (response.success) {
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};
